(function(){
"use strict";
const API="https://aya-shopify-pricing-api.serifinejewelry.workers.dev";
const K="_custom_price";
const root=()=>window.Shopify?.routes?.root||"/";
const n=v=>{const x=parseFloat(v);return Number.isFinite(x)&&x>0?x:null};
async function cart(){const r=await fetch(root()+"cart.js",{credentials:"same-origin",cache:"no-store"});if(!r.ok)throw new Error("Could not read cart");return r.json()}
async function api(body){const r=await fetch(API+"/api/draft-order",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify(body)});const t=await r.text();let d=null;try{d=JSON.parse(t)}catch(e){}if(!r.ok||!d?.ok)throw new Error(d?.error||("AYA checkout server HTTP "+r.status));return d}
async function go(btn,e){
 if(e){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation()}
 btn.disabled=true;const old=btn.textContent;btn.textContent="Processing...";
 try{
  const c=await cart();if(!c.items?.length)throw new Error("Your cart is empty.");
  const custom=c.items.some(i=>n(i.properties?.[K])!==null);
  if(!custom){window.location.href=root()+"checkout";return}
  const lineItems=c.items.map(i=>{const p=n(i.properties?.[K]);const a=Object.entries(i.properties||{}).filter(([k,v])=>v!=null&&String(v).trim()&&k!==K&&k!=="_aya_custom_pricing"&&k!=="_aya_pricing_payload").map(([key,value])=>({key,value:String(value)}));const x={variantId:"gid://shopify/ProductVariant/"+i.variant_id,quantity:Math.max(1,Number(i.quantity)||1),customAttributes:a};if(p!==null)x.price=Number(p.toFixed(2));return x});
  console.log("[AYA] Draft Order payload",lineItems);
  const d=await api({lineItems});if(!d.invoiceUrl)throw new Error("AYA checkout URL was not returned.");
  window.location.href=d.invoiceUrl;
 }catch(err){console.error("[AYA] Checkout failed",err);alert("AYA Checkout Error:\n\n"+(err?.message||err));btn.disabled=false;btn.textContent=old||"Checkout"}
}
function bind(){
 document.querySelectorAll("#checkout,#CartDrawer-Checkout,button[name=checkout]").forEach(b=>{
  if(b.dataset.ayaFixed==="1")return;b.dataset.ayaFixed="1";
  b.addEventListener("click",e=>go(b,e),true);
 });
 document.querySelectorAll("form[action='/checkout'],form[action$='/checkout']").forEach(f=>{
  if(f.dataset.ayaFixedForm==="1")return;f.dataset.ayaFixedForm="1";
  f.addEventListener("submit",e=>{const b=f.querySelector("#checkout,button[name=checkout]")||document.querySelector("#checkout");if(b)go(b,e)},true);
 });
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",bind);else bind();
new MutationObserver(bind).observe(document.body,{childList:true,subtree:true});
})();